import { createI18n } from 'vue-i18n'
import de from './locales/de'
import en from './locales/en'
import fr from './locales/fr'
import hr from './locales/hr'
import sl from './locales/sl'

export type AvailableLocales = 'en' | 'hr' | 'sl' | 'de' | 'fr'

export interface LocaleMeta {
    code:  AvailableLocales
    label: string
    flag:  string
}

export const supportedLocales: LocaleMeta[] = [
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'hr', label: 'Hrvatski', flag: '🇭🇷' },
    { code: 'sl', label: 'Slovenščina', flag: '🇸🇮' },
    { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
]

const getInitialLocale = (): AvailableLocales => {
    if (typeof localStorage !== 'undefined') {
        const saved = localStorage.getItem('nervuseye_locale') as AvailableLocales | null
        if (saved && ['en', 'hr', 'sl', 'de', 'fr'].includes(saved)) {
            return saved
        }
    }
    return 'en'
}

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           getInitialLocale(),
    fallbackLocale:   'en',
    messages:         { en, hr, sl, de, fr },
    availableLocales: ['en', 'hr', 'sl', 'de', 'fr'],
})

export function setAppLocale(locale: AvailableLocales) {
    i18n.global.locale.value = locale
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('nervuseye_locale', locale)
    }
}

export default i18n
